import { createApi } from '@reduxjs/toolkit/query/react';
import { IResponseApi } from '@/types/apis/response';
import { IParamsApi } from '@/types/apis/params';
import customBaseAdminQuery from './fetchBaseAdmin';

export const apiAdminCaller = createApi({
  reducerPath: 'apiAdminCaller',
  refetchOnMountOrArgChange: 30,
  baseQuery: customBaseAdminQuery(),
  // get data settings
  endpoints: (builder) => ({
    fetchProfile: builder.query<IResponseApi.IGetUserProfile, void>({
      query: () => {
        return {
          url: 'user/profile',
          method: 'GET',
        };
      },
    }),
    getHolidayBanner: builder.query<IResponseApi.IGetHolidayBanner, IParamsApi.IGetHolidayBanner>({
      query: (input) => {
        return {
          url: 'banner/active',
          method: 'GET',
          params: {
            ...input,
            appKey: 'blockify_age_verification',
            platform: 'shopline',
          },
        };
      },
    }),
  }),
});
